// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".noFlex[data-v-62583939]{-webkit-box-flex:0!important;-ms-flex:none!important;flex:none!important}", ""]);
// Exports
module.exports = exports;
